export default "__VITE_ASSET__DAfMzt72__"